// extracted by mini-css-extract-plugin
module.exports = {"moreInformation":"style_moreInformation__3kZqY"};